module.exports = __webpack_public_path__ + "static/media/mono-black.2311f37e.svg";